import fr from "./fr.json";
import en from "./en.json";
import nl from "./nl.json";

const translations = { en, fr, nl };

// Langue courante (par défaut "nl")
let currentLanguage = process.env.REACT_APP_DEFAULT_LOCALE;

// Liste des listeners (React ou autres) qui veulent être notifiés
const listeners = new Set();

// Fonction utilitaire pour décoder \u00e9 → é
function decodeUnicode(str) {
  try {
    return JSON.parse(`"${str}"`);
  } catch {
    return str;
  }
}

// Fonction pour traduire une clé
export function t(key) {
  if (key === undefined) {
    return undefined;
  }
  if (typeof key !== "string") {
    return key;
  }  
  if (key === "") {
    return key;
  }  

  key = decodeUnicode(key);
  let value = translations[currentLanguage];
  value = value?.[key];
  return value || ("[missing " + key + "]");
}

// Changer la langue
export function setLanguage(lang) {
  currentLanguage = lang;
  listeners.forEach((cb) => cb(lang));
}

// Obtenir la langue courante
export function getLanguage() {
  return currentLanguage;
}

// S'abonner aux changements (React ou autre)
export function subscribe(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback); // unsubscribe
}

export function tLang(key, lang) {
  if (key === undefined) {
    return undefined;
  }  
  if (typeof key !== "string") {
    return key;
  }
  if (key === "") {
    return key;
  }
  key = decodeUnicode(key);
  let value = translations[lang];
  value = value?.[key];
  return value || ("[missing " + key + "]");
}

export function tMulti(key) {
  if (key === undefined) {
    return undefined;
  }  
  if (typeof key !== "string") {
    return key;
  }
  key = decodeUnicode(key);
  var elems = key.split(", ");
  var res = [];
  elems.forEach((elem) => {
    res.push(t(elem));
  });
  return res.join(", ");
}

export function tTag(key) {
  const regex = new RegExp(`<${currentLanguage}>(.*?)<\/${currentLanguage}>`, "s");
  const match = key.match(regex);

  if (match && match[1]) {
    return match[1].trim();
  }
  const regex2 = new RegExp(`<${process.env.REACT_APP_DEFAULT_LOCALE}>(.*?)<\/${process.env.REACT_APP_DEFAULT_LOCALE}>`, "s");
  const match2 = key.match(regex2);
  if (match2 && match2[1]) {
    return match2[1].trim();
  }

  return false; // return false if no translation available
}